<template>
    <rkm-overlay>
        <rkm-layout-body title="Gerenciamento diário">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/gerenciamento-diario/List'

export default {
    components: {List},
}
</script>